import { LoginResponse } from 'interfaces/user.types';
import request from './request';

const authService = {
  login: (data: LoginResponse) => request.post('auth/user/', data),
};

export default authService;
